import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { FreightTrackingsDetailValue } from "../../../core/models/invoice-preview/FreightTrackingsDetailValue";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { exportExcel } from "../../../core/services/shared.service";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { FreightDetailsComponent } from "../../bcledger/components/freight-details/freight-details.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-order-tracking",
  templateUrl: "./invoice-preview-order-tracking.component.html",
  styleUrls: ["./invoice-preview-order-tracking.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    ModalStackerComponent,
    FreightDetailsComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class InvoicePreviewOrderTrackingComponent
  implements OnInit, OnDestroy, OnChanges
{
  showSmallLoader = false;
  orderTrackingDisplayModal = false;
  trackingNumber = "";
  @Input() salesId = "";
  @Input() projId = "";
  @Input() orderTrackingGridListing: FreightTrackingsDetailValue[] = [];
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() calculateTotalForAllLines = false;
  @Output() closeModalEvent = new EventEmitter();
  @Input() forModalStacker = false;
  totalSalePrice = 0;

  constructor(
    private _loaderService: LoaderService,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService
  ) {}

  ngOnInit(): void {
    if (this.salesId && this.projId && !this.calculateTotalForAllLines) {
      this.getOrderTrackingDataAgainstSaleOrder(this.salesId, this.projId);
    }
  }

  exportExcel() {
    exportExcel(this.orderTrackingGridListing, "OrderTracking Listing");
  }

  getOrderTrackingDataAgainstSaleOrder(salesId: string, projId: string) {
    this._loaderService.setLoaderState(true);
    const oDataFilter = `?$filter=SalesId eq '${salesId}' and ProjId eq '${projId}'`;
    this._invoicePreviewSummaryService
      .getFreightTrackingLine(oDataFilter)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.orderTrackingGridListing = res.data;
          this._loaderService.setLoaderState(false);
          this.totalSalePrice = this.orderTrackingGridListing.reduce(
            (sum, el) => (sum += el.SellPrice),
            0
          );
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onTrackingNumberSelection(trackingNumber: string) {
    if (trackingNumber) {
      this.trackingNumber = trackingNumber;
      this.orderTrackingDisplayModal = true;
    }
  }

  closeModalFromOrderTracking() {
    this.orderTrackingDisplayModal = false;
  }

  addScollHiddenClass() {
    this.scrollHiddenStatus.emit();
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  ngOnChanges(): void {
    this.calculateTotals();
  }

  calculateTotals() {
    if (this.calculateTotalForAllLines && this.salesId && this.projId) {
      const oDataFilter = `?$filter=SalesId eq '${this.salesId}' and ProjId eq '${this.projId}'`;
      this._invoicePreviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.data && res?.data?.length > 0) {
              this.totalSalePrice = res.data.reduce(
                (sum, el) => (sum += el.SellPrice),
                0
              );
            }
          },
        });
    } else {
      this.totalSalePrice = this.orderTrackingGridListing.reduce(
        (sum, el) => (sum += el.SellPrice),
        0
      );
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
